// Pantalla "Ya está publicado" tras crear un partido abierto (T10). Adaptada de OpenMatchJoinSuccess /
// ReservaSuccess (clases `.success`, `.tick`, `.receipt`): el POST ya devuelve el partido, no hay consulta
// de estado. Ofrece el mensaje listo para WhatsApp (con `/partidos/compartir/<shareToken>`), copiarlo y el
// link de gestión `/partidos/<id>?token=` (T11 lo resuelve). El manageToken ya lo guardó el hook.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import RIcon from "../../reservas/components/ReservasIcons";
import { buildShareMessage, formatMatchDay, manageUrl, missingLabel, shareUrl } from "../openMatchesModel";

const OpenMatchPublished = ({ info }) => {
	const [copied, setCopied] = useState(false);
	const match = info.match || {};
	const link = shareUrl(info.shareToken);
	const text = buildShareMessage({
		clubName: match.clubName,
		date: match.date,
		slotStart: match.slotStart,
		missing: match.missing,
		link,
	});
	const copy = async () => {
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);
			setTimeout(() => setCopied(false), 2500);
		} catch (_) {}
	};
	return (
		<div className="success" data-testid="open-match-published">
			<div className="tick">
				<div className="ring">
					<RIcon name="check" width={38} height={38} />
				</div>
			</div>
			<h1>Ya está publicado</h1>
			<p className="ssub">
				<strong>{missingLabel(match.missing)}</strong> para completar el partido. Compartilo para que se sume el resto.
			</p>

			<div className="receipt open-match-receipt">
				<div className="receipt-top">
					<div className="rt-name">{match.clubName}</div>
				</div>
				<div className="receipt-grid">
					<div className="rg">
						<div className="l"><RIcon name="cal" width={14} height={14} /> Fecha</div>
						<div className="v">{`${formatMatchDay(match.date)} ${dayjs(match.date).format("DD/MM")}`}</div>
					</div>
					<div className="rg">
						<div className="l"><RIcon name="clock" width={14} height={14} /> Horario</div>
						<div className="v">{match.slotStart} - {match.slotEnd} hs</div>
					</div>
					{match.courtName && (
						<div className="rg">
							<div className="l"><RIcon name="ticket" width={14} height={14} /> Cancha</div>
							<div className="v">{match.courtName}</div>
						</div>
					)}
				</div>
			</div>

			<p data-testid="open-match-share-text" style={{ fontSize: 14, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 12, padding: 12, wordBreak: "break-word" }}>
				{text}
			</p>

			<p style={{ fontSize: 13, color: "#6b7280", fontWeight: 600 }}>
				Cada jugador paga su parte en el club. Te avisamos cuando se complete o si hay cambios.
			</p>

			<div className="success-actions">
				<a className="r-btn-primary" style={{ padding: "13px 28px", textDecoration: "none" }} href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer">
					Compartir por WhatsApp
				</a>
				<button type="button" className="r-btn-soft" onClick={copy}>
					{copied ? "Mensaje copiado" : "Copiar mensaje"}
				</button>
				{(info.manageToken || info.matchId || match?._id) && (
					<Link
						className="r-btn-soft"
						style={{ textDecoration: "none" }}
						to={info.manageToken ? manageUrl(info.matchId || match._id, info.manageToken, "") : `/partidos/${info.matchId || match._id}`}
					>
						Ver mi partido
					</Link>
				)}
			</div>
		</div>
	);
};

export default OpenMatchPublished;
